<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col
          cols="2"
          v-if="
            roles.read_profit_store ||
            roles.read_profit_seller ||
            roles.read_profit_product
          "
        >
          <v-select
            :items="dashboardTypeList"
            :item-text="(obj) => obj.text"
            :item-value="(obj) => obj.value"
            label="Report Type"
            dense
            outlined
            v-model="report_type"
            @change="
              showSellerReport = false;
              showStoreReport = false;
              showIdeaReport = false;
              showProductReport = false;
              showProductMonthlyReport = false;
              showProductFBSummaryReport = false;
              showProductFBDayByDayReport = false;
              showGGCampPerformReport = false;
            "
          ></v-select>
        </v-col>

        <v-col
          cols="2"
          v-if="
            report_type == 'product_profit' ||
            report_type == 'product_profit_by_month' ||
            report_type == 'product_fb_summary' ||
            report_type == 'product_fb_day_by_day' ||
            report_type == 'google_campaign_performance'
          "
        >
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                label="Report Time Range"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates"
              range
              scrollable
              @change="
                showProductReport = false;
                showProductMonthlyReport = false;
                showProductFBSummaryReport = false;
                showProductFBDayByDayReport = false;
                showGGCampPerformReport = false;
              "
              v-if="menu2"
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-col>
        <v-col cols="2" v-else>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            persistent
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="report_month"
                label="Report Month"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="report_month"
              type="month"
              scrollable
              @change="
                showStoreReport = false;
                showSellerReport = false;
                showIdeaReport = false;
              "
              v-if="menu3"
            ></v-date-picker>
            <!-- <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker> -->
          </v-menu>
        </v-col>

        <v-col
          cols="2"
          v-if="
            report_type == 'product_profit' ||
            report_type == 'product_profit_by_month' ||
            report_type == 'product_fb_summary' ||
            report_type == 'product_fb_day_by_day' ||
            report_type == 'google_campaign_performance'
          "
        >
          <v-select
            v-model="sitesSelected"
            :items="listSites"
            :item-text="(obj) => obj.showName"
            :item-value="(obj) => obj.code"
            outlined
            dense
            chips
            small-chips
            label="Select Sites"
            multiple
            @input="searchInput = null"
            :search-input.sync="searchInput"
            @change="
              showProductReport = false;
              showProductMonthlyReport = false;
              showProductFBSummaryReport = false;
              showProductFBDayByDayReport = false;
              showGGCampPerformReport = false;
            "
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="sitesSelected.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Select All </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider> </template
          ></v-select>
        </v-col>

        <v-col cols="2" v-if="report_type == 'product_profit' || report_type == 'product_profit_by_month'">
          <v-select
            :items="listProductType"
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            label="Product Type"
            dense
            outlined
            multiple
            v-model="productTypeSelected"
            @input="searchInputType = null"
            :search-input.sync="searchInputType"
            @change="showProductReport = false;showProductMonthlyReport = false"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="sitesSelected.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Select All </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider> 
            </template>
          </v-select>
        </v-col>

        <v-col cols="2" v-if="report_type == 'product_profit_by_month'">
              <v-autocomplete
                :items="listTags"
                :item-text="(obj) => obj.tag_name"
                :item-value="(obj) => obj.tag_name"
                label="Tags"
                dense
                outlined
                v-model="tagsSelected"
                multiple
                @change="showProductMonthlyReport = false"
              ></v-autocomplete>
            </v-col>

        <v-col
          cols="2"
          v-if="
            report_type == 'product_profit' ||
            report_type == 'product_fb_summary'
          "
        >
          <v-select
            :items="listIdea"
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            label="Idea"
            dense
            outlined
            multiple
            v-model="listIdeaSelected"
            @change="
              showProductReport = false;
              showProductFBSummaryReport = false;
            "
          ></v-select>
        </v-col>

        <v-col
          cols="2"
          v-if="
            (report_type == 'product_profit' ||
              report_type == 'product_fb_summary' ||
              report_type == 'product_fb_day_by_day') &&
            dates.length > 0 &&
            sitesSelected.length > 0
          "
        >
          <v-btn
            color="success"
            @click="onshowProductReport"
            v-if="report_type == 'product_profit'"
            >View Report</v-btn
          >
          <v-btn
            color="success"
            @click="onshowProductFBSumReport"
            v-if="report_type == 'product_fb_summary'"
            >View Report</v-btn
          >
          <v-btn
            color="success"
            @click="onshowProductFBByDayReport"
            v-if="report_type == 'product_fb_day_by_day'"
            >View Report</v-btn
          >
        </v-col>

        <v-col
          cols="2"
          v-else-if="report_type == 'seller_profit' && report_month != ''"
        >
          <v-btn color="success" @click="onshowSellerReportData"
            >View Report</v-btn
          >
        </v-col>

        <v-col
          cols="2"
          v-else-if="report_type == 'store_profit' && report_month != ''"
        >
          <v-btn color="success" @click="onshowStoreReportData"
            >View Report</v-btn
          >
        </v-col>
        <v-col
          cols="2"
          v-else-if="report_type == 'idea_profit' && report_month != ''"
        >
          <v-btn color="success" @click="onshowIdeaReport">View Report</v-btn>
        </v-col>

        <v-col
          cols="2"
          v-else-if="
            report_type == 'google_campaign_performance' &&
            report_month != '' &&
            sitesSelected.length > 0
          "
        >
          <v-btn color="success" @click="onshowGGReport">View Report</v-btn>
        </v-col>

        <v-col
          cols="2"
          v-else-if="report_type == 'product_profit_by_month' && report_month != ''"
        >
          <v-btn
            color="success"
            @click="onshowProductMonthlyReport"
            v-if="report_type == 'product_profit_by_month'"
            >View Report</v-btn
          >
        </v-col>

        <v-col cols="2" v-else>
          <v-btn color="success" disabled>View Report</v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <template v-if="showSellerReport">
        <sellerProfit :report_type="report_type" :report_month="report_month" />
      </template>

      <template v-if="showStoreReport">
        <storeProfit :report_type="report_type" :report_month="report_month" />
      </template>

      <template v-if="showIdeaReport">
        <ideaProfit :report_type="report_type" :report_month="report_month" />
      </template>

      <template v-else-if="showProductReport">
        <productProfit
          :report_type="report_type"
          :report_month="dates"
          :store_codes="sitesSelected"
          :listIdeaSelected="listIdeaSelected"
          :productTypeSelected="productTypeSelected"
        />
      </template>

      <template v-else-if="showProductMonthlyReport">
        <productMonthlyProfit
          :report_type="report_type"
          :report_month="dates"
          :store_codes="sitesSelected"
          :productTypeSelected="productTypeSelected"
          :tagsSelected = "tagsSelected"
        />
      </template>

      <template v-else-if="showProductFBSummaryReport">
        <productFBSumProfit
          :report_type="report_type"
          :report_month="dates"
          :store_codes="sitesSelected"
          :listIdeaSelected="listIdeaSelected"
        />
      </template>

      <template v-else-if="showProductFBDayByDayReport">
        <productFBByDayProfit
          :report_type="report_type"
          :report_month="dates"
          :store_codes="sitesSelected"
        />
      </template>

      <template v-else-if="showGGCampPerformReport">
        <ggCampPerform
          :report_type="report_type"
          :report_month="dates"
          :store_codes="sitesSelected"
        />
      </template>
    </v-col>
  </div>
</template>

<script>
import storeProfit from "./c-profit-store";
import sellerProfit from "./c-profit-seller";
import productProfit from "./c-profit-product";
import productMonthlyProfit from "./c-profit-product-monthly";
import ideaProfit from "./c-profit-idea.vue";
import productFBSumProfit from "./c-profit-product-fb-summary.vue";
import productFBByDayProfit from "./c-profit-product-fb-by-day.vue";
import ggCampPerform from "./c-profit-google-camp-performance.vue";
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "DashboardContainer",

  components: {
    storeProfit,
    sellerProfit,
    ideaProfit,
    productProfit,
    productMonthlyProfit,
    productFBSumProfit,
    productFBByDayProfit,
    ggCampPerform,
  },

  props: {
    userId: String,
  },

  data: () => ({
    dashboardTypeList: [],
    report_type: "",
    menu2: false,
    menu3: false,
    report_month: new Date().toISOString().substr(0, 7),
    showSellerReport: false,
    showProductReport: false,
    showProductMonthlyReport: false,
    showStoreReport: false,
    showIdeaReport: false,
    showProductFBSummaryReport: false,
    showProductFBDayByDayReport: false,
    showGGCampPerformReport: false,
    dates: [],
    listSites: [],
    sitesSelected: [],
    listIdeaSelected: [],
    listIdea: [],
    listProductType: [],
    productTypeSelected: "",
    tagsSelected:[],
    searchInput: null,
    searchInputType: null,
    marketing: null,
    manager: null,
    admin: null,
    roles: [],
  }),

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    likesAllStore() {
      return this.sitesSelected.length === this.listSites.length;
    },
    likesSomeStore() {
      return this.sitesSelected.length > 0 && !this.likesAllStore;
    },
    icon() {
      if (this.likesAllStore) return "mdi-close-box";
      if (this.likesSomeStore) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  methods: {
    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "profit-site-loadData"
      );

      if (
        this.roles.read_profit_product
        // && (this.checkRoles('Administrator') || this.checkRoles('General Manager')))
      ) {
        if (currentSession.accessToken) {
          await axios
            .get(window.domain + "personalize-products/get-data", {
              headers: { Authorization: currentSession.accessToken },
            })
            .then((response) => {
              // console.log(this.AuthStr)
              console.log(response);
              this.listSites = response.data.data.sites;
              this.listIdea = response.data.data.ideas;
              this.listProductType = response.data.data.productTypes;
              this.listTags = response.data.data.tags_v2;

              for (var i of this.listSites) {
                if (i.brand_name) i["showName"] = i.code + " - " + i.brand_name;
                else i["showName"] = i.code;
              }
            })
            .catch((error) => {
              console.log("Error:", error);
            });
        } else {
          console.log(
            "currentSession profit-site-loadData-undefined: ",
            currentSession
          );
        }
      }
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    //SHOW REPORT
    onshowStoreReportData() {
      this.showStoreReport = false;
      this.showStoreReport = true;
    },
    onshowSellerReportData() {
      this.showSellerReport = false;
      this.showSellerReport = true;
    },
    onshowProductReport() {
      this.showProductReport = false;
      this.showProductReport = true;
    },

    onshowProductMonthlyReport() {
      this.showProductMonthlyReport = false;
      this.showProductMonthlyReport = true;
    },
    
    onshowProductFBSumReport() {
      this.showProductFBSummaryReport = false;
      this.showProductFBSummaryReport = true;
    },
    onshowProductFBByDayReport() {
      this.showProductFBDayByDayReport = false;
      this.showProductFBDayByDayReport = true;
    },
    onshowIdeaReport() {
      this.showIdeaReport = false;
      this.showIdeaReport = true;
    },
    onshowGGReport() {
      this.showGGCampPerformReport = false;
      this.showGGCampPerformReport = true;
    },

    //END SHOW REPORT

    toggle() {
      //action khi bam vao nut select all
      this.$nextTick(() => {
        if (this.likesAllStore) {
          this.sitesSelected = [];
        } else {
          // this.selectedFilter = this.filterData.slice()
          // this.filterDataTable(this.selectedFilter)
          this.sitesSelected = [];
          for (const i of this.listSites) {
            this.sitesSelected.push(i.code);
          }
        }
      });
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("dashboard");

    if (this.roles.read_profit_store) {
      this.dashboardTypeList.push({ text: "Store", value: "store_profit" });
    }

    if (this.roles.read_profit_seller) {
      this.dashboardTypeList.push({ text: "Seller", value: "seller_profit" });
    }

    if (this.roles.read_profit_idea) {
      this.dashboardTypeList.push({ text: "Idea", value: "idea_profit" });
    }

    if (this.roles.read_profit_product) {
      this.dashboardTypeList.push({ text: "Product", value: "product_profit" });
      this.dashboardTypeList.push({ text: "Product Monthly", value: "product_profit_by_month" });
      
      this.dashboardTypeList.push({
        text: "Product FB Summary",
        value: "product_fb_summary",
      });
      this.dashboardTypeList.push({
        text: "Product FB Day By Day",
        value: "product_fb_day_by_day",
      });
    }

    if (this.roles.read_profit_google_campaign) {
      this.dashboardTypeList.push({
        text: "Google Campaign Performance",
        value: "google_campaign_performance",
      });
    }

    console.log("roles: ", this.roles);
    if (
      this.roles.read_profit_store ||
      this.roles.read_profit_seller ||
      this.roles.read_profit_product ||
      this.roles.read_profit_idea ||
      this.roles.read_profit_google_campaign
    ) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>